import Loader from 'reusable/mobx-helpers/Loader'
import { makeAutoObservable } from 'mobx'
import { apiClient } from 'api/trpc/trpc-client'
import { CreateClientContactAutocompleteParams } from './CreateClientContactAutocomplete'
import { FormHandlerConfig, formHandler } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'
import { GapAutocompleteOption } from 'features/gap-components/autocomplete/types/GapAutocompleteTypes'
import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils'
import { AdvisorClientContactDto } from "@gap/backend/app-services/advisor/client/contact/models/AdvisorClientContactDto"

const addNewContactOption: GapAutocompleteOption = {
   id: 'add-new-contact',
   label: '+ Create contact'
}

export default class CreateClientContactAutocompleteStore {
   loader = new Loader(false)
   clientUsers: GapAutocompleteOption[] = []
   fields: { userIds: string[] } = {
      userIds: []
   }
   showCreateClientContactModal = false
   sp

   constructor(sp: Omit<CreateClientContactAutocompleteParams, 'label'>) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get formHandler() {
      return formHandler(this.fields, {
         userIds: { type: 'any' }
      } satisfies FormHandlerConfig)
   }

   get userOptions(): GapAutocompleteOption[] {
      if (!this.clientUsers) {
         return [addNewContactOption]
      }
      return [...this.clientUsers, addNewContactOption]
   }

   fetch = async () => {
      await this.loader.executeLoading(async () => {
         if ((this.sp.clientUsers && this.sp.clientUsers.length > 0) || this.sp.dontFetchContacts === true) {
            this.clientUsers = this.sp.clientUsers || []
         } else {
            const clientUsers = await apiClient.advisor.getClientContacts.query({ clientId: this.sp.advisorClientId, includeHiddenStatus: true, includeArchivedStatus: true })

            this.clientUsers = clientUsers.map(user => ({
               id: user.id,
               label: `${user.name} (${user.email})`
            }))
         }
         this.fields.userIds = this.sp.value
      })
   }

   /**
    * When the user clicks the "Create Contact" option
   */
   onCreateClientContactClickHandler = async () => {
      this.showCreateClientContactModal = true
   }

   closeCreateClientContactModal = () => {
      this.showCreateClientContactModal = false
   }

   /**
    * When the user selects a contact from the autocomplete
   */
   onContactIdsChange = (selectedContactList: string[]) => {
      if (selectedContactList.find(contact => contact === addNewContactOption.id)) {
         this.showCreateClientContactModal = true
      } else {
         this.fields.userIds = selectedContactList
         this.sp.onChange(selectedContactList)
      }
   }

   /**
    * When a new contact is created
   */
   onNewContactCreated = (advisorContact: AdvisorClientContactDto.entity) => {
      this.sp.onChange(this.fields.userIds, advisorContact)
      this.showCreateClientContactModal = false
   }
}

export const { Provider: CreateClientContactAutocompleteStoreProvider, useProvidedStore: useCreateClientContactAutocompleteStore } =
   createStoreContext(CreateClientContactAutocompleteStore)
